<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-card class="inner-block customer-agent">
            <b-card-header>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input type="text" placeholder="Search customer agents..." v-model="filter"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-col class="bg-white p-3">
                <b-col class="page-block"><strong>{{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{
                    pageCount }} {{ $translate('Total') }}:
                        {{ pagination.total }}</strong></b-col>
                <b-col class="overflow-auto w-100 mt-4">

                    <b-table :fields="fields" striped hover responsive :items="customerAgents"
                        :per-page="itemsPerPage" :current-page="currentPage" :filter="filter">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button variant="pink-button" @click="$emit('show-item', row.item.id)" class="mr-2">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center" :prev-text="$translate('previous')"
                        :next-text="$translate('next')" v-model="pagination.page" :total-rows="pagination.total"
                        :per-page="pagination.pageSize" aria-controls="customerTable" pills align="right"></b-pagination>
                </b-col>
            </b-row>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'CustomerAgents-ListItems',
    mixins: [popupMixins],
    props: ['title'],

    data() {
        return {
            query: '',
            filter: '',
            itemsPerPage: 15,
            tableLoading: false,
            currentPage: 1,
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()

    },
    watch: {
        customerAgents: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'code', label: this.$translate('agent_id') },
                { key: 'first_name', label: this.$translate('first_name') },
                { key: 'last_name', label: this.$translate('last_name') },
                { key: 'email', label: this.$translate('email') },
                { key: 'phone', label: this.$translate('telephone') },
                { key: 'company_name', label: this.$translate('company_name') },
            ]
        },
        customerAgents() {
            return this.$store.state.customerAgents.customer_agents
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        pagination() {
            return this.$store.state.customerAgents.pagination || {}
        },
        rows() {
            return this.items.length
        }

    },

    methods: {
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        async doSearch() {
            try {
                this.tableLoading = true
                const {
                    query,
                    pagination: { page },
                } = this
                await this.$store.dispatch('customerAgents/fetch', {
                    query,
                    page,
                })
            } catch (err) {
                console.error('loading error', err)
            }
        },

    },
}
</script>
<style></style>
